import React, { useState, useEffect } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { ReactComponent as CLoseIcon } from "./DummyIcons/CloseButton.svg";
import {
  DataGrid,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
} from "@mui/x-data-grid";
import { Modal, Box, TextField, Button, Fab, Tooltip } from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import axios from "axios";
import "./BillingPayment.scss";
// import "./Product.scss";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";
import { format } from "date-fns";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { CheckToken } from "../login/AccessToken";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { toast } from "react-toastify";
import SideNavbar from "./SideNavbar";
import CloseIcon from "@mui/icons-material/Close";
import NoDataPage from "./NoDataPage";
import { Card, Grid, Typography, Divider } from "@mui/material";
import NavigationIcon from "@mui/icons-material/Navigation";

import Icon from "../doctor-console/Utils/Icons";

import { ReactComponent as CalendarIcon } from './DummyIcons/calendar-silhouette 2.svg';
// import { ReactComponent as CLoseIcon } from "./IconsForTiles/CloseButton.svg";

import SaveAlt from "@mui/icons-material/SaveAlt";
import { CSVLink } from "react-csv";
import jsPDF from "jspdf";
import "jspdf-autotable";

const Product = () => {
  const today = new Date().toISOString().split("T")[0];
  const Token = () => {
    const check = CheckToken();
    console.log(check);
    setAuthToken(sessionStorage.getItem("accessToken"));
    return check;
  };

  const {
    control,
    handleSubmit,
    reset,
    register,
    formState: { errors },
  } = useForm();
  const {
    control: control1,
    handleSubmit: handleSubmit1,
    reset: reset1,
    register: register1,
    formState: { errors: errors1 },
    setValue: setValue1,
    getValues,
  } = useForm();
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") || ""
  );
  const [facilityName, setFacilityName] = useState(
    sessionStorage.getItem("facility_name") || ""
  );

  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;

  const headers = {
    Authorization: `Bearer ${authToken}`,
  };

  const [isModalOpen, setModalOpen] = useState(false);
  const [serviceList, setServiceList] = useState([]);
  const [editItemId, setEditItemId] = useState(null);
  const [deactivationReason, setDeactivationReason] = useState("");
  const [isDeactivationModalOpen, setDeactivationModalOpen] = useState(false);
  const history = useHistory();
  useEffect(() => {
    if (
      sessionStorage.getItem("accessToken") == undefined &&
      sessionStorage.getItem("accessToken") == null
    ) {
      history.push("/login");
    }
  }, []);
  const fetchServiceList = () => {
    if (authToken !== "") {
      axios
        .get(`${REACT_APP_BACKEND_ROUTE_URL}get_all_medical_products/`, {
          headers: headers,
        })
        .then((res) => {
          const servicesWithId = res.data.product_list.map(
            (service, index) => ({
              ...service,
              id: index + 1,
              status: getStatusText(service.expired, service.active),
            })
          );
          setServiceList(servicesWithId);
        })
        .catch((error) => {
          console.error("Error fetching service list:", error);
        });
    }
  };
  const getStatusText = (expired, active) => {
    if (!expired && active) {
      return "Active";
    } else {
      return "Inactive";
    }
  };

  useEffect(() => {
    fetchServiceList();
  }, [authToken]);

  const handleAddItem = () => {
    setModalOpen(true);
    reset(); // Reset form fields on modal open
  };

  const handleEditItem = (row) => {
    setModalOpen(true);
    reset({
      name: row.name,
      description: row.description,
      fee: row.fee,
      expiry_date: row.expiry_date,
    });
    setEditItemId(row.medical_service_id);
  };

  const handleModalClose = () => {
    setModalOpen(false);
    reset();
    reset({
      name: "",
      description: "",
      fee: "",
      expiry_date: "",
    });
    setEditItemId(null);
  };

  const handleSaveItem = (data) => {
    if (authToken !== "") {
      const requestConfig = {
        headers: headers,
      };

      if (editItemId) {
        const requestData = {
          medical_product_id: editItemId,
          hip_id: facilityName,
          ...data,
        };

        axios
          .post(
            `${REACT_APP_BACKEND_ROUTE_URL}update_medical_product/`,
            JSON.stringify(requestData),
            requestConfig
          )
          .then((res) => {
            toast.success(res.data.message);
            setModalOpen(false);
            reset();
            setEditItemId(null);
            fetchServiceList();
          })
          .catch((error) => {
            console.error("Error adding or updating medical service:", error);
          });
      } else {
        const dataWithHipId = {
          ...data,
          hip_id: facilityName,
        };

        axios
          .post(
            `${REACT_APP_BACKEND_ROUTE_URL}add_medical_product/`,
            dataWithHipId,
            requestConfig
          )
          .then((res) => {
            toast.success(res.data.message);
            setModalOpen(false);
            reset();
            fetchServiceList();
          })
          .catch((error) => {
            console.error("Error adding medical service:", error);
          });
      }
    }
  };

  const getRowClassName = (params) => {
    return "custom-row";
  };

  const handleDeleteItem = (id) => {
    if (authToken !== "") {
      // Include the id in the request payload
      const requestData = {
        medical_product_id: id,
        hip_id: "HLTHTEK_DEV",
      };

      const requestConfig = {
        headers: headers,
      };

      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}deactivate_medical_product/`,
          JSON.stringify(requestData),
          requestConfig
        )
        .then(() => {
          toast.success("Deleted!");
          fetchServiceList();
        })
        .catch((error) => {
          console.error("Error deleting medical service:", error);
        });
    }
  };
  const handleToggleItem = (id, active) => {
    // If deactivating, open the deactivation modal
    if (active) {
      setEditItemId(id);
      setDeactivationModalOpen(true);
    } else {
      // If activating, proceed with the toggle immediately
      toggleMedicalService(id, active, "");
    }
  };

  const toggleMedicalService = (id, active, reason) => {
    const action = active
      ? "deactivate_medical_product"
      : "activate_medical_product";

    const requestData = {
      medical_product_id: id,
      hip_id: sessionStorage.getItem("facility_name") || "",
      deactivation_reason: reason,
    };

    const requestConfig = {
      headers: headers,
    };

    axios
      .post(
        `${REACT_APP_BACKEND_ROUTE_URL}${action}/`,
        JSON.stringify(requestData),
        requestConfig
      )
      .then(() => {
        toast.success(active ? "Deactivated!" : "Activated!");
        fetchServiceList();
      })
      .catch((error) => {
        console.error(
          `Error ${active ? "deactivating" : "activating"} medical service:`,
          error
        );
      });
  };

  const handleDeactivationModalClose = () => {
    setDeactivationModalOpen(false);
    setDeactivationReason("");
    setValue1("description", "");
  };

  const handleDeactivateConfirm = (data) => {
    console.log(data);
    setDeactivationModalOpen(false);
    toggleMedicalService(editItemId, true, data.description);
    setDeactivationReason(data.description);
    setValue1("description", "");
  };

  const generatePdf = () => {
    const doc = new jsPDF();

    // const tableColumns = [
    //   "ID",
    //   "Name",
    //   "Description",
    //   "Fee",
    //   "Added on",
    //   "Expiry date",
    //   "Status",
    // ];
    doc.autoTable({
      head: [["ID", "Name", "Description", "Fee", "Added on", "Expiry date", "Status"]],
      body: serviceList.map((product) => [
        product.id,
        product.name,
        product.description,
        product.fee,
        product.added_on,
        product.expiry_date,
        product.status,
      ])
    });
    doc.save('Products_list.pdf');
  };

  const generateCsvData = () => {
    return serviceList.map((product) => ({
      "ID": product.id,
      "Name": product.name,
      "Description": product.description,
      "Fee": product.fee,
      "Added on": product.added_on,
      "Expiry date": product.expiry_date,
      "Status": product.status,
    }));
  };

  const modalHeaderHeight = 60;
  const modalFooterHeight = 70;
  return (
    <>
      <Dialog
        open={isDeactivationModalOpen}
        onClose={handleDeactivationModalClose}
        style={{
          backdropFilter: "blur(5px)", // Applies blur to the background
          backgroundColor: "rgba(0, 0, 0, 0.5)", // Optional: Adds a semi-transparent overlay
        }}
      >
        <DialogTitle>Deactivate Medical Service</DialogTitle>
        <DialogContent>
          <form
            onSubmit={handleSubmit1((data) => {
              handleDeactivateConfirm({
                description: data.description,
              });
            })}
          >
            <div className="col-12">
              <label htmlFor="description" className="required-label">
                Reason for Deactivation
              </label>
              <div className="form-group">
                {/* <i className="icon-news form-group-icon"></i> */}
                <textarea
                  className="form-control"
                  placeholder="Enter Reason"
                  name="description"
                  {...register1("description", {
                    required: "Reason for deactivation is required",
                  })}
                />
                {errors1.description && (
                  <p className="error-message">{errors1.description.message}</p>
                )}
              </div>
            </div>
            <DialogActions>
              <button
                onClick={handleDeactivationModalClose}
                type="button"
                className="btn btn__secondary btn__rounded btn__block mt-2"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn__secondary btn__rounded btn__block mt-2"
              >
                Deactivate
              </button>
            </DialogActions>
          </form>
        </DialogContent>
      </Dialog>

      <Modal
        open={isModalOpen}
        onClose={handleModalClose}
        style={{
          // backdropFilter: "blur(5px)", // Applies blur to the background
          backgroundColor: "rgba(0, 0, 0, 0.5)", // Optional: Adds a semi-transparent overlay
        }}
      >
        <Box
          sx={{
            width: {
              xs: "100%",
              sm: "75%",
              md: "75%",
              lg: "40%",
              xl: "30%",
            },
            p: 2,
            mt: 3,
            mx: "auto",
            bgcolor: "background.paper",
            borderRadius: "10px",
            padding: 0,
          }}
        >
          <Box
            sx={{
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              // backgroundImage: `url(${Icons.modal_blue})`,
              backgroundColor: "#213360",
              height: { xs: 50, sm: modalHeaderHeight },
              // borderBottom: "1px solid #ddd",
              borderBottom: "1px solid rgba(255,255,255,0.15)",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              px: { xs: 1, sm: 2 },
              borderTopLeftRadius: "8px",
              borderTopRightRadius: "8px",
              flexShrink: 0,
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontSize: "20px",
                fontWeight: 550,
                color: "#FFFFFF",
              }}
            >
              Add New Product
            </Typography>
            <CLoseIcon
              onClick={handleModalClose}
              style={{
                width: "20px",
                height: "20px",
                cursor: "pointer",
                transition: "all 0.3s ease",
                "&:hover": {
                  border: "1px solid #000",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                  transform: "scale(1.1)",
                },
              }}
            />
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              bgcolor: "background.paper",
              p: 2,
              borderRadius: 1,
              width: "100%",
              height: "100%",
            }}
          >
            <form
              onSubmit={handleSubmit(handleSaveItem)}
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                height: "100%",
              }}
            >
              <div className="col-12" style={{ flex: "1" }}>
                <label htmlFor="name" className="required-label">
                  Name{" "}
                </label>
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Name"
                    name="name"
                    {...register("name", { required: "Name is required" })}
                    style={{ width: "100%" }}
                  />
                  {errors.name && <p className="error-message">{errors.name.message}</p>}
                </div>
              </div>

              <div className="col-12" style={{ flex: "1" }}>
                <label htmlFor="description" className="required-label">
                  Description{" "}
                </label>
                <div className="form-group">
                  <textarea
                    className="form-control"
                    placeholder="Enter Description"
                    name="description"
                    {...register("description", {
                      required: "Description is required",
                    })}
                    style={{ width: "100%" }}
                  />
                  {errors.description && (
                    <p className="error-message">{errors.description.message}</p>
                  )}
                </div>
              </div>

              <div className="col-12 d-flex" style={{ marginBottom: "0.5rem", padding: "0" }}>
                <div className="col-6" style={{ flex: "1" }}>
                  <label htmlFor="fee" className="required-label">
                    Fee{" "}
                  </label>
                  <div className="form-group">
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Enter Fee"
                      name="fee"
                      {...register("fee", { required: "Fee is required" })}
                      style={{ width: "100%" }}
                    />
                    {errors.fee && <p className="error-message">{errors.fee.message}</p>}
                  </div>
                </div>

                <div className="col-6" style={{ flex: "1" }}>
                  <label htmlFor="expiry_date" className="required-label">
                    Expiry Date{" "}
                  </label>
                  <div className="form-group position-relative">
                    <input
                      type="date"
                      className="form-control"
                      placeholder="Enter Expiry Date"
                      id="expiry_date"
                      name="expiry_date"
                      max="2050-01-01"
                      min={today}
                      {...register("expiry_date", {
                        required: "Expiry Date is required",
                      })}
                      style={{ width: "100%" }}
                    />
                    <i
                      className="position-absolute"
                      style={{ right: "10px", top: "50%", transform: "translateY(-50%)" }}
                    >
                      <CalendarIcon
                        onClick={() => document.getElementById("expiry_date").showPicker?.()}
                      />
                    </i>
                  </div>
                  {errors.expiry_date && (
                    <p className="error-message">{errors.expiry_date.message}</p>
                  )}
                </div>
              </div>

              <div className="col-12 d-flex" style={{ marginBottom: "0.5rem", padding: "0" }}>
                <div className="col-6" style={{ flex: "1" }}>
                  <button
                    type="submit"
                    className="btn btn__secondary btn__block mt-2"
                    style={{
                      width: "100%",
                      marginBottom: "1rem",
                      borderRadius: "10px",
                      border: "1px solid #125386",
                    }}
                  >
                    SAVE
                  </button>
                </div>
                <div className="col-6" style={{ flex: "1" }}>
                  <button
                    onClick={handleModalClose}
                    type="button"
                    className="btn btn__secondary btn__block mt-2"
                    style={{
                      width: "100%",
                      borderRadius: "10px",
                      border: "1px solid #125386",
                    }}
                  >
                    CANCEL
                  </button>
                </div>
              </div>
            </form>
          </Box>
        </Box>
      </Modal>

      {/* <Modal open={isModalOpen} onClose={handleModalClose}>
        <Box
          sx={{
            width: {
              xs: "100%",
              sm: "75%", // 75% width on small screens
              md: "75%", // 50% width on medium screens
              lg: "40%", // 40% width on large screens
              xl: "30%", // 30% width on extra-large screens
            },
            p: 2,
            mt: 3,
            mx: "auto",
            bgcolor: "background.paper",
            borderRadius: 1,
          }}
        >
          <form onSubmit={handleSubmit(handleSaveItem)}>
            <div className="col-12">
              <label htmlFor="name" className="required-label">
                Name{" "}
              </label>
              <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Name"
                  name="name"
                  {...register("name", { required: "Name is required" })}
                />
                {errors.name && (
                  <p className="error-message">{errors.name.message}</p>
                )}
              </div>
            </div>

            <div className="col-12">
              <label htmlFor="description" className="required-label">
                Description{" "}
              </label>
              <div className="form-group">
                <textarea
                  className="form-control"
                  placeholder="Enter Description"
                  name="description"
                  {...register("description", {
                    required: "Description is required",
                  })}
                />
                {errors.description && (
                  <p className="error-message">{errors.description.message}</p>
                )}
              </div>
            </div>

            <div className="col-12 d-flex">
              <div className="col-6 pr-2">
                <label htmlFor="fee" className="required-label">
                  Fee{" "}
                </label>
                <div className="form-group">
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Enter Fee"
                    name="fee"
                    {...register("fee", { required: "Fee is required" })}
                  />
                  {errors.fee && (
                    <p className="error-message">{errors.fee.message}</p>
                  )}
                </div>
              </div>
              <div className="col-6 pl-2">
                <label htmlFor="expiry_date" className="required-label">
                  Expiry Date{" "}
                </label>
                <div className="form-group position-relative">
                  <input
                    type="date"
                    className="form-control"
                    placeholder="Enter Expiry Date"
                    id="expiry_date"
                    name="expiry_date"
                    max="2050-01-01"
                    min={today}
                    {...register("expiry_date", {
                      required: "Expiry Date is required",
                    })}
                  />
                  <i className="position-absolute" style={{ right: '10px', top: '50%', transform: 'translateY(-50%)' }}>
                    <CalendarIcon
                      onClick={() =>
                        document.getElementById("expiry_date").showPicker?.()
                      }
                    />
                  </i>
                </div>
                {errors.expiry_date && (
                  <p className="error-message">
                    {errors.expiry_date.message}
                  </p>
                )}
              </div>
            </div>

            <div className="col-12">
              <button
                type="submit"
                className="btn btn__secondary btn__rounded btn__block mt-2"
              >
                Save
              </button>
              <button
                onClick={handleModalClose}
                type="button"
                className="btn btn__secondary btn__rounded btn__block mt-2"
              >
                Cancel
              </button>
            </div>
          </form>
        </Box>
      </Modal> */}

      <SideNavbar />
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "1fr auto", // One column for text, one for button
          alignItems: "center",
          padding: "12px",
          gap: "20px", // Space between text and button
          marginBottom: "5px",
          // paddingX: { xs: 2, sm: 3 }, // Add padding for smaller screens
        }}
      >
        <p
          style={{
            fontSize: "32px",
            fontWeight: "bold",
            textAlign: "left",
            color: "#172935",
            margin: 0, // Remove default margin to align properly
          }}
        >
          Available Products
        </p>
        <button
          onClick={handleAddItem}
          type="button"
          className="btn btn__secondary btn__rounded btn__block mt-2"
          style={{
            backgroundColor: "#0E3F66",
            borderRadius: "10px",
            fontSize: "14px",
            paddingX: { xs: 2, sm: 3 },
            paddingY: 1,
            textTransform: "none",
            // "&:hover": {
            //   backgroundColor: "#0C3555",
            // },
          }}
        >
          + Add Product
        </button>
      </Box>
      <div className="display-flex">
        {serviceList !== undefined && serviceList.length > 0 ? (
          <DataGrid
            style={{ maxHeight: "90vh" }}
            rows={serviceList}
            columns={[
              { field: "id", headerName: "ID", width: 150 },
              { field: "name", headerName: "Name", width: 200 },
              { field: "description", headerName: "Description", width: 200 },
              { field: "fee", headerName: "Fee", width: 100 },
              {
                field: "added_on",
                headerName: "Added On",
                width: 150,
                renderCell: (params) => (
                  <span>
                    {params.row.added_on
                      ? new Date(params.row.added_on)
                        .toISOString()
                        .split("T")[0]
                      : ""}
                  </span>
                ),
              },
              {
                field: "expiry_date",
                headerName: "Expiry date",
                width: 150,
                renderCell: (params) => {
                  const currentDate = new Date();
                  const expiryDate = new Date(params.row.expiry_date);
                  const isExpired = expiryDate < currentDate;
                  const formattedExpiryDate = format(expiryDate, "yyyy-MM-dd");

                  return (
                    <span style={{ color: isExpired ? "red" : "inherit" }}>
                      {formattedExpiryDate}
                    </span>
                  );
                },
              },
              {
                field: "status",
                headerName: "Status",
                width: 120,
                renderCell: (params) => {
                  const isExpired = params.row.expired;
                  const isActive = params.row.active;

                  let statusColor = "";
                  let statusText = "";

                  if (!isExpired && isActive) {
                    statusColor = "green";
                    statusText = "Active";
                  } else {
                    statusColor = "red";
                    statusText = "Inactive";
                  }

                  return (
                    <span style={{ color: statusColor }}>{statusText}</span>
                  );
                },
              },
              {
                field: "edit",
                headerName: "Edit",
                width: 100,
                renderCell: (params) => (
                  <Tooltip title="Edit">
                    <EditIcon
                      onClick={() => handleEditItem(params.row)}
                      style={{ cursor: "pointer", color: "#0D233F" }}
                    />
                  </Tooltip>
                ),
              },
              {
                field: "toggle",
                headerName: "Action",
                width: 100,
                renderCell: (params) => (
                  <>
                    {params.row.expired ? (
                      <Tooltip title="Inactive">
                        <ToggleOffIcon
                          style={{ cursor: "not-allowed", color: "gray" }}
                        />
                      </Tooltip>
                    ) : params.row.active ? (
                      <Tooltip title="Active">
                        <ToggleOnIcon
                          onClick={() =>
                            handleToggleItem(
                              params.row.medical_service_id,
                              params.row.active
                            )
                          }
                          style={{ cursor: "pointer", color: "#0D233F" }}
                        />
                      </Tooltip>
                    ) : (
                      <Tooltip title="Inactive">
                        <ToggleOffIcon
                          onClick={() =>
                            handleToggleItem(
                              params.row.medical_service_id,
                              params.row.active
                            )
                          }
                          style={{ cursor: "pointer", color: "#0D233F" }}
                        />
                      </Tooltip>
                    )}
                  </>
                ),
              },
            ]}
            components={{
              Toolbar: () => (
                <Grid
                  container
                  spacing={2}
                  alignItems="center"
                  justifyContent="space-between"
                  sx={{
                    mb: 2,
                  }}
                >
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={8}
                    sx={{ display: "flex", gap: 1 }}
                  >
                    <GridToolbarColumnsButton />
                    <GridToolbarFilterButton />
                    <GridToolbarDensitySelector />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    sx={{
                      display: "flex",
                      gap: 1,
                      justifyContent: { xs: "center", sm: "flex-end" },
                    }}
                  >
                    <Button
                      variant="text"
                      color="primary"
                      onClick={() => generatePdf()}
                      startIcon={<SaveAlt />}
                    >
                      Download PDF
                    </Button>
                    <CSVLink
                      data={generateCsvData()}
                      filename={"scan_share_records.csv"}
                      target="_blank"
                    >
                      <Button
                        variant="text"
                        color="primary"
                        startIcon={<SaveAlt />}
                      >
                        Download CSV
                      </Button>
                    </CSVLink>
                  </Grid>
                </Grid>
              ),
            }}
            initialState={{
              pagination: {
                paginationModel: { page: 0, pageSize: 10 },
              },
            }}
            pageSizeOptions={[5, 10]}
            getRowClassName={getRowClassName}
            sx={{
              "& .MuiDataGrid-root": {
                border: "1px solid #e0e0e0",
                borderRadius: "4px",
                fontFamily: "Arial, sans-serif",
              },
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#125386",
                color: "white",
                fontSize: "13px",
                fontWeight: "600",
                minHeight: "48px !important",
                "& .MuiDataGrid-columnHeaderTitle": {
                  color: "white",
                  fontWeight: "600",
                  fontSize: "13px",
                },
                "& .MuiDataGrid-columnHeader": {
                  borderRight: "1px solid rgba(255, 255, 255, 0.3)",
                  padding: "0 12px",
                },
                "& .MuiDataGrid-columnHeader:last-child": {
                  borderRight: "none",
                },
                "& .MuiDataGrid-iconButtonContainer": {
                  color: "white",
                },
                "& .MuiDataGrid-menuIcon": {
                  color: "white",
                },
                "& .MuiDataGrid-sortIcon": {
                  color: "white",
                },
                "& .MuiDataGrid-columnHeaderSortable": {
                  "& .MuiDataGrid-sortIcon": {
                    color: "white",
                  },
                },
                "& .MuiDataGrid-columnHeaderTitleContainer": {
                  "& .MuiDataGrid-sortIcon": {
                    color: "white",
                  },
                },
                "& .MuiSvgIcon-root": {
                  color: "white",
                },
              },
              "& .MuiDataGrid-row": {
                backgroundColor: "white",
                minHeight: "40px !important",
                "&:nth-of-type(even)": {
                  backgroundColor: "white",
                },
                "&:hover": {
                  backgroundColor: "#f8f9fa",
                },
                "&.Mui-selected": {
                  backgroundColor: "#e3f2fd",
                  "&:hover": {
                    backgroundColor: "#e3f2fd",
                  },
                },
                borderBottom: "1px solid #e0e0e0",
              },
              "& .MuiDataGrid-cell": {
                borderRight: "1px solid #e0e0e0",
                fontSize: "12px",
                color: "#374151",
                padding: "8px 12px",
                minHeight: "40px !important",
                "&:last-child": {
                  borderRight: "none",
                },
                "&:focus": {
                  outline: "none",
                },
              },
              "& .MuiDataGrid-cellContent": {
                fontSize: "12px",
                color: "#374151",
                fontWeight: "400",
              },
              "& .MuiDataGrid-footerContainer": {
                backgroundColor: "#f8f9fa",
                borderTop: "1px solid #e0e0e0",
                minHeight: "52px",
              },
              "& .MuiTablePagination-root": {
                color: "#374151",
                fontSize: "12px",
              },
              "& .MuiDataGrid-toolbarContainer": {
                backgroundColor: "#f8f9fa",
                borderBottom: "1px solid #e0e0e0",
                padding: "8px 16px",
              },
            }}
          />
        ) : (
          <NoDataPage />
        )}
      </div>
    </>
  );
};

export default Product;
